<template>
  <div class="upload-form">
    <label class="ant-btn my-btn" >
      <input type="file" style="display: none" @change="uploadFile" />
      <a-icon type="upload"></a-icon>{{$t('uploadFile')}}
    </label>
    <a-tag v-for="(item, index) in upLoadfiles" :key="item.files.lastModified" closable @close.stop="deleteFiles(item, index)">
      <div class="file-name">{{ item.files.name }}</div>
    </a-tag>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import ajax from '@/ajax/axios-ajax.js'
  import apis from '@/apis/index.js'
  export default {
    data () {
      return {
        upLoadfiles: []
      }
    },
    computed: {
      ...mapState({
        visitorInfo: 'visitorInfo'
      })
    },
    methods: {
      // 上传文件
      uploadFile (ev) {
        let files = ev.target.files[0]
        // 对文件进行判断
        const justifyResult = this.justifyFile(files)
        if (!justifyResult) {
          return
        }
        let params  = new FormData()
        params.append('tenantId', this.visitorInfo.tenantId)
        params.append('file', files)
        ajax.post(apis.chat.upload, params).then((res) => {
          if (res.success) {
            this.upLoadfiles.push({
              deleteFiles: { ...res.data },
              files: files
            })
            let cont = ''
            let url = res.data.url
            let urlType = url.split('.')[url.split('.').length - 1]
            if (urlType === 'jpg' || urlType === 'JPG' || urlType === 'png' || urlType === 'PNG' || urlType === 'gif' || urlType === 'GIF' || urlType === 'svg' || urlType === 'SVG') {
              cont = `<img src="${res.data.url}">`
            } else if (urlType === 'doc' || urlType === 'docx' || urlType === 'xls' || urlType === 'xlsx' || urlType === 'ppt' || urlType === 'txt' || urlType === 'pdf') {
              cont = `<a href=${res.data.url} download target="__blank">下载：${res.data.name}</a>`
            } else {
              cont = res.data.url
            }
            this.$emit('change', cont)
            this.$message.success(this.$t('successful'))
          } else {
            this.$message.error(this.$t('fail'))
          }
        })
      },
      deleteFiles (item, index) {
        let params = {
          ...item.deleteFiles
        }
        ajax.post(apis.chat.uploadCancel, params).then(res => {
          console.log(res, '====')
          if (res.success) {
            this.upLoadfiles.splice(index, 1)
            this.$message.success('删除成功')
          }
        })
      },
      justifyFile (files) {
        let size = 0
        let fileSize = files.size
        if (!files) {
          return false
        }
        if (this.upLoadfiles.length >= 10) {
          this.$message.error('上传文件个数不能超过10个')
          return false
        }
        this.upLoadfiles.forEach(item => {
          size += item.files.size
        })
        size += fileSize
        if (size > 200 * 1024) {
          this.$message.error('文件大小不能超过200M')
          return false
        }
        return true
      }
    }
  }
</script>
<style scoped lang="less">
  .my-btn {
    display: flex;
    align-items: center;
    width: 104px;
    margin-top: 5px;
  }
  /deep/.ant-tag {
    height: 30px;
    line-height: 30px;
    margin-top: 10px;
  }
  .file-name {
    vertical-align: top;
    max-width: 610px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
  }
</style>
